// extracted by mini-css-extract-plugin
export default {"container":"common_container__8faFk","desc":"common_desc__d8IV1"};